import { useEditorState } from "@/store";

export const localizeCircleFlowText = (text?: string | null): string => {
  if (!text) return "";
  const separatorIndex = text.indexOf("*");
  if (separatorIndex === -1) return text;
  const { language } = useEditorState.getState();
  const raw =
    language === "en" ? text.slice(0, separatorIndex) : text.slice(separatorIndex + 1);
  return raw.replace(/_/g, " ");
};
